import { Loader2 } from 'lucide-react';

interface LoadingSpinnerProps {
  message?: string;
  size?: number;
  color?: string;
}

export function LoadingSpinner({ message = 'Chargement...', size = 24, color = '#2563eb' }: LoadingSpinnerProps) {
  return (
    <div style={{ padding: '60px 20px', textAlign: 'center' }}>
      <Loader2
        size={size}
        color={color}
        style={{ animation: 'spin 1s linear infinite', margin: '0 auto 12px', display: 'block' }}
      />
      {message && (
        <p style={{ color: '#94a3b8', fontSize: '0.9rem', margin: 0 }}>{message}</p>
      )}
      <style>{`@keyframes spin { from { transform: rotate(0deg) } to { transform: rotate(360deg) } }`}</style>
    </div>
  );
}
